import { useEffect, useState } from 'react';
import './index.less';
import SearchIcon from '@/components/Common/Icons/SearchIcon';
import { Input } from 'antd';
import { isEmpty } from 'lodash-es';
import { useQueryParams } from '@/shared/hooks';
import { ParamKey } from '@/shared/types/url-params';
import CloseIcon from '@/components/Common/Icons/CloseIcon';

const SearchBar = () => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [searchKey, setSearchKey] = useState<string>('');
  const { queryParams, setQueryParams } = useQueryParams<{}>();
  const searchKeyFromUrl = queryParams.get(ParamKey.SEARCH);

  useEffect(() => {
    if (!isEmpty(searchKeyFromUrl)) {
      setIsActive(true);
    }

    setSearchKey(searchKeyFromUrl);
  }, [searchKeyFromUrl]);

  const handleSearch = () => {
    setQueryParams({ [ParamKey.SEARCH]: searchKey });
  };

  const clearSearch = () => {
    setSearchKey('');
  };

  return (
    <div className="search-bar-box">
      {isActive ? (
        <div className="inner">
          <div className="search-icon" onClick={handleSearch}>
            <SearchIcon style={{ fill: '#000' }} />
          </div>
          <Input
            placeholder="Search for a product..."
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            onBlur={() => {
              if (isEmpty(searchKey)) {
                setIsActive(false);
              }
            }}
            onPressEnter={handleSearch}
          />
          <div className="close-tag-btn" onClick={clearSearch}>
            <CloseIcon />
            <span>Clear</span>
          </div>
        </div>
      ) : (
        <div className="supplier-search-icon" onClick={() => setIsActive(true)}>
          <SearchIcon style={{ fill: '#6B6B6B', width: '12px' }} />
          <p className="supplier-search-placeholder">Search for a product</p>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
